
import { connect } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import store from "@/store";
import http from "@/http";
import { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { message, Modal } from "antd";
import HeaderNotice from "./header-notice";
import "@/assets/sass/header.scss";

function OfficialHeader(props) {
  const { t } = useTranslation();
  const location = useLocation();

  const modalRef = useRef();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [ko, setKo] = useState(false);
  const toLogin = () => navigate("/login");
  const redeemModalRef = useRef();
  const loginOut = () => {
    http.post("/logout").then((res) => {
      store.dispatch({ type: "logout" });
      toLogin();
      // window.location.reload();
    });
  };

  const userBtn = useRef();
  let closeUserBtn = () => {
    $(".cs-munu_toggle").trigger("click");
    $(userBtn.current).trigger("click");
  };

  let closeUserBtn1 = () => {
    $(".cs-munu_toggle").trigger("click");
    $(userBtn.current).trigger("click");
  };

  //2025-05-03
  const [mobileMenutoggle, setMobileMenutoggle] = useState("");
  const [mobileMenu, setMobileMenu] = useState("");

  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  let closeLanguageBtn = () => {
    setShowLanguageMenu(false);
  };

  //2025-05-03
  let mobileMenuonoff = () => {
    if (mobileMenutoggle === "") {
      setMobileMenutoggle("cs-toggle_active");
      setMobileMenu("active");
    } else {
      setMobileMenutoggle("");
      setMobileMenu("");
    }
  };

  //2026-04-29
  let donatelink = () => {
    navigate("/donation");
  };

  const noticeBtn = useRef();
  let closeNoticeBtn = () => {
    $(noticeBtn.current).trigger("click");
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };
  const handleOk = () => {
    setOpen(false);
  };
  const setConversion = () => {
    redeemModalRef.current.openConfirm();
  };
  useEffect(() => {
    $(window).on("click", () => {
      $("#header .cs-toggle_btn.active").trigger("click");
    });
  }, []);
  console.log('location.pathname', location.pathname)
  const isAdmin = !(props.userInfo.roles?.[0]?.roleKey === 'common');
  return (
    <>
      <div className={`overlay ${mobileMenu}`} onClick={() => mobileMenuonoff()}></div >
      <header
        id="header"
        className="cs-site_header cs-style1 cs-sticky-header"
        onClick={(event) => event.stopPropagation()}
      >
        <Modal
          title="Warning"
          open={open}
          onCancel={handleCancel}
          onOk={handleOk}
        >
          {ko ? (
            <p>
              지금 모바일 브라우저에서 지갑을 연결하려고 하십니다. 메타마스크
              앱의 브라우저에서 이 웹사이트를 열고 지갑을 연결하세요.
            </p>
          ) : (
            <p>
              You are connecting the wallet in mobile browser. Please open this
              websit in the browser of your metamask app and connect the wallet.
            </p>
          )}
        </Modal>
        <div className="cs-main_header">
          <div className={`container-fluid container-fluid-clc ${(location.pathname === '/official/home2' || location.pathname === '/') ? 'container-fluid-official' : ''}`}>
            <div className="cs-main_header_in">
              <div className="cs-main_header_left">
                <a className="cs-site_branding" href="#/">
                  {(location.pathname === '/official/home2' || location.pathname === '/') ? <img
                    src="/assets/img/footerlogo.png"

                    alt="Logo"
                  /> : <img
                    src="/assets/img/logo.png"

                    alt="Logo"
                  />}

                  {/* <img
                    src="/assets/img/logo.png"
                    className="d-md-block d-none"
                    alt="Logo"
                  />
                  <img
                    src="/assets/img/logo_icon.png"
                    className="d-md-none d-block"
                    alt="Logo"
                  /> */}
                </a>
              </div>
              <div className="cs-main_header_right">
                <div className="cs-nav_wrap flex-1">
                  <div className="cs-nav_out">
                    <div className="cs-nav_in">
                      <div
                        className="cs-nav"
                        style={{ justifyContent: "center" }}
                      >
                        <ul className={`cs-nav_list ${mobileMenu}  GmarketSans weight400`}>
                          <li>
                            <Link onClick={closeUserBtn1} to="/official/home2">
                              {t("components.home")}
                            </Link>
                          </li>
                          <li>
                            <Link onClick={closeUserBtn1} to="/introduction-consortium">
                              {t("components.foundation")}
                            </Link>
                          </li>
                          <li>
                            <Link onClick={closeUserBtn1} to="/project">
                              {t('components.project')}
                            </Link>
                          </li>
                          <li>
                            <Link onClick={closeUserBtn1} to="/methodological">
                              {t('components.methodology')}
                            </Link>
                          </li>
                          <li>
                            <Link onClick={closeUserBtn1} to="/announcement">
                              {t('components.news')}
                            </Link>
                          </li>
                          <li>
                            <a onClick={closeUserBtn1} href={`/nft.html#/`}>
                              {t('components.marketplace')}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`cs-munu_toggle ${mobileMenutoggle}`} onClick={() => mobileMenuonoff()}><span>전체메뉴</span></div>

                <div className="cs-header_btns_wrap">
                  <div className="cs-header_btns">

                    <a className={`pointer wallter-user ${(location.pathname === '/official/home2' || location.pathname === '/') ? 'wallter-user_main' : 'wallter-user'}`} onClick={() => donatelink()}><span>{t('menu_donation')}</span></a>

                    <div className="cs-toggle_box cs-notification_box">
                      <div
                        className="cs-toggle_btn cs-header_icon_btn cs-center"
                        onClick={() => setShowLanguageMenu(!showLanguageMenu)}
                      >
                        <img src="/assets/img/btn_language.png" alt="" />
                      </div>
                      <div className={`cs-toggle_body cs-user_info_box ${showLanguageMenu ? 'active' : ''}`}>
                        <ul className="cs-notification_list">
                          <li
                            className="cs-notification_item"
                            onClick={() => {
                              store.dispatch({
                                type: "changeLanguage",
                                language: "ko",
                              });
                              closeLanguageBtn();
                            }}
                          >
                            한국어
                          </li>
                          <li
                            className="cs-notification_item"
                            onClick={() => {
                              store.dispatch({
                                type: "changeLanguage",
                                language: "en",
                              });
                              closeLanguageBtn();
                            }}
                          >
                            English
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default connect((state) => {
  return {
    userInfo: state.userInfo,
    isLogin: state.isLogin,
    language: state.language,
  };
})(OfficialHeader);
